import { render, staticRenderFns } from "./formMyHistoryTask.vue?vue&type=template&id=77410a8b&"
import script from "./formMyHistoryTask.vue?vue&type=script&lang=js&"
export * from "./formMyHistoryTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports